import {throwErrorWithMessage} from "@web-libs/core/errors";

const baseUrl = process.env.BASE_URL || process.env.NEXT_PUBLIC_BASE_URL;

if (baseUrl === undefined) {
    const errorMessage = 'BASE_URL is undefined. Define it in the environment variables.'
    throwErrorWithMessage(errorMessage)
}

export default baseUrl;
